import { createSlice } from '@reduxjs/toolkit'

// Detecta el tema del sistema
const getSystemTheme = () =>
  window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light'

// Estado inicial
const initialState = {
  theme: localStorage.getItem('theme') || getSystemTheme()
}

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload
      localStorage.setItem('theme', action.payload)
    },
    toggleTheme: (state) => {
      state.theme = state.theme === 'light' ? 'dark' : 'light'
      localStorage.setItem('theme', state.theme)
    },
    resetThemeToSystem: (state) => {
      const systemTheme = getSystemTheme()
      state.theme = systemTheme
      localStorage.removeItem('theme')
    }
  }
})

export const { setTheme, toggleTheme, resetThemeToSystem } = themeSlice.actions

export default themeSlice.reducer
